import _styled from '@emotion/styled/base';
import 'react';
import { SECONDARY_NAV_WIDTH, SECONDARY_NAV_HEIGHT_COLLAPSED, EMOTION_ID } from './constants.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { Spacing } from '../primitives/spacing.js';
import { mediaQuery } from '../primitives/media-queries.js';
import { grid } from '@hubble/tokens/web';

const StyledHeader = _styled("div", {
  target: "eupe7nj10"
})();
const StyledContent = _styled("main", {
  target: "eupe7nj9"
})();
const StyledSecondaryNav = _styled("div", {
  target: "eupe7nj8"
})();
const StyledForm = _styled("div", {
  target: "eupe7nj7"
})();
const StyledSidePanel = _styled("aside", {
  target: "eupe7nj6"
})();
const StyledFooter = _styled("footer", {
  target: "eupe7nj5"
})();
const OverflowWrapper = _styled("div", {
  target: "eupe7nj4"
})({
  name: "1emh2t",
  styles: "overflow:auto;height:100%"
} );
const FormWrapper = _styled("div", {
  target: "eupe7nj3"
})("max-width:", ({
  hasSecondaryNav
}) => hasSecondaryNav ? `calc(100% - ${SECONDARY_NAV_WIDTH})` : '100%', ";");
const Container = _styled("div", {
  target: "eupe7nj2"
})({
  name: "160wl6g",
  styles: "flex:1 1 auto;position:relative;width:100%;height:100%;overflow:hidden"
} );
const ContentWrapper = _styled("div", {
  target: "eupe7nj1"
})("display:grid;width:100%;margin:0 auto;max-width:", grid.main.xl.minWidth, ";padding:", grid.main.xs.margin, " ", grid.main.xs.margin, " 0;box-sizing:border-box;", StyledHeader, "{grid-column:1/-1;min-width:0;}", StyledContent, "{grid-column:1/-1;min-width:0;}", StyledSidePanel, "{grid-column:1/-1;}");
const OuterContainerStyled = _styled("div", {
  target: "eupe7nj0"
})("display:flex;flex-direction:column;height:100%;position:relative;", StyledHeader, "{flex:none;}", StyledForm, "{margin:0 auto;width:448px;padding:", Spacing.scale[6], " ", Spacing.scale[2], " ", Spacing.scale[8], ";}", StyledFooter, "{flex:none;}@media ", mediaQuery.mobileXsDown, "{", StyledForm, "{width:100%;}", ContentWrapper, "{gap:", grid.main.xs.gutter, ";grid-template-columns:repeat(", grid.main.xs.columns, ", 1fr);}}@media ", mediaQuery.tabletSmUp, "{", ContentWrapper, "{grid-template-columns:repeat(", grid.main.sm.columns, ", 1fr);gap:", grid.main.sm.gutter, ";padding-right:", grid.main.sm.margin, ";padding-left:", grid.main.sm.margin, ";}}@media ", mediaQuery.tabletSmDown, "{", StyledSecondaryNav, "+", OverflowWrapper, "{height:calc(100% - ", SECONDARY_NAV_HEIGHT_COLLAPSED, ");}", FormWrapper, "{max-width:100%;}}@media ", mediaQuery.tabletMdUp, "{", Container, "{display:flex;}", StyledSecondaryNav, "{height:100%;width:", SECONDARY_NAV_WIDTH, ";flex:none;overflow:auto;}", OverflowWrapper, "{flex:auto;}", StyledSecondaryNav, "+", OverflowWrapper, " ", ContentWrapper, "{max-width:calc(", grid.main.xl.minWidth, " - ", SECONDARY_NAV_WIDTH, ");", StyledContent, "{grid-column:1/-1;}", StyledSidePanel, "{grid-column:1/-1;}}", ContentWrapper, "{grid-template-columns:repeat(", grid.main.lg.columns, ", 1fr);", StyledContent, "{grid-column:span 7;}", StyledContent, ":only-child{grid-column:1/-1;}", StyledSidePanel, "{grid-column:span 5;}}}@media ", mediaQuery.desktopLgUp, "{", StyledSecondaryNav, "+", OverflowWrapper, " ", ContentWrapper, "{", StyledContent, "{grid-column:span 8;}", StyledContent, ":only-child{grid-column:1/-1;}", StyledSidePanel, "{grid-column:span 4;}}", ContentWrapper, "{gap:", grid.main.lg.gutter, ";padding-right:", grid.main.lg.margin, ";padding-left:", grid.main.lg.margin, ";", StyledContent, "{grid-column:span 8;}", StyledSidePanel, "{grid-column:span 4;}}}");
function OuterContainer({
  children
}) {
  return jsx(OuterContainerStyled, {
    "data-emotion-id": EMOTION_ID,
    children: children
  });
}

export { Container, ContentWrapper, FormWrapper, OuterContainer, OverflowWrapper, StyledContent, StyledFooter, StyledForm, StyledHeader, StyledSecondaryNav, StyledSidePanel };
